export enum ActivityPageTabs {
  ALL = 'ALL',
  NOTE = 'NOTE',
  CALL = 'CALL',
  EMAIL = 'EMAIL',
}

export enum ActivityType {
  NOTE = 'NOTE',
  CALL = 'CALL',
  EMAIL = 'EMAIL',
}

export interface ActivityListFilters {
  search: string;
  callFilters: {
    callStatus: string[];
    callDirection: string[];
  };
}

export interface ActivityCardProps<Entity> {
  entity: Entity;
  onUpdate?: VoidFunction;
  onDelete?: VoidFunction;
}
